export const ANDROID_NAMESPACE = 'VisaAndroid' as const;
export const SDK_NAMESPACE = 'VisaCheckoutSDK' as const;
